import { defineElement, html, i18n } from '@webtides/element-js';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';

import staticText from '@zeg/base-light-module/frontend/js/helper/static-texts-lookup';
import {
    getFormattedDiscountPrice,
    isPartialPrice,
} from '@zeg/base-light-module/frontend/js/helper/price-model-helper';

import styles from './fh-product-card.css';
import BaseProductCard from '@zeg/base-light-module/frontend/components/structures/_product/product-card/product-card.class.js';

class ProductCard extends BaseProductCard {
    constructor() {
        super({ styles: [styles] });
    }

    renderSaving() {
        if (!getFormattedDiscountPrice(this.currentFrame.prices)) {
            return '';
        }

        return html`
            <div class="absolute leading-none right-0 bottom-0 mb-4 text-white font-bold w-full">
                <div class="flex justify-end min-w-0">
                    <p class="frame-saving pl-10 pr-8 py-2 truncate bg-grey-300">
                        ${isPartialPrice(this.currentFrame.prices)
                            ? staticText('partiallyReduced', i18n('productCard.saving.partial'))
                            : staticText('allReduced', i18n('productCard.saving.all'))}
                    </p>
                </div>
            </div>
        `;
    }

    renderSpacerElement() {
        if (!this.showSpacerElement) return;
        return html`<div class="pt-12 xl:pt-8"></div>`;
    }

    renderTagline() {
        const tagline = this.currentFrame.brand || `&nbsp;`;
        return html`<div class="brand-name">${unsafeHTML(tagline)}</div>`;
    }
}

defineElement('product-card', ProductCard);
